var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluxibilityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 270.93 270.93",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m138.09 134.78c-2.3544 0-3.5319 1.1774-3.5319 3.532v10.595c0 2.3545 1.1775 3.532 3.5319 3.532l36.68 0.0805h9e-3c5.9154 0 8.9914 1.945 11.334 4.7091 2.3406 2.762 3.6036 6.8006 3.6054 10.073v9e-3l0.0126 15.582-8.3453-0.0266c-1.9438 0-1.9447-7e-4 -0.97277 1.943l17.246 32.738c0.97185 2.035 0.97204 2.0338 1.8833 0.0597l17.305-32.798c0.97186-1.9441 0.98491-1.8947-0.95881-1.8947-0.36218 0-4.6112 0-8.4971-0.0223h-3e-3l-0.0125-15.504v-0.0782c0-7.3214-2.3746-15.094-7.7951-21.491-5.4174-6.393-14.227-10.955-24.785-10.959h-0.0179z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    strokeWidth: 0.9122
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.3 5.1425-19.749 36.41c-1.1686 2.3371-1.1691 2.3364 1.1682 2.3364h9.9632v18.79c0 3.5188-1.36 7.8595-3.8764 10.829-2.5182 2.9718-5.8243 5.1059-12.184 5.1059h-58.708c-7.8711 0-16.23 2.594-23.107 8.4215-6.8729 5.8242-11.776 15.294-11.782 26.646v0.021l-0.20624 22.298 0.1275 22.411 0.25488 61.328v6e-3c0 6.3597-2.0917 9.6653-5.0635 12.184-2.9694 2.5163-3.9298 3.8764-10.829 3.8764h-22.197v-9.4207c0-2.3372-3.03e-4 -2.3387-2.3374-1.17l-36.484 19.13c-2.3736 1.0956-2.3734 1.0942 0.07322 2.2628l36.413 19.61c2.337 1.1686 2.3354 1.169 2.3354-1.1682v-10.258h22.188c7.8711 0 16.23-2.5537 23.107-8.3812 6.873-5.8242 11.782-15.294 11.782-26.646v-0.0209l0.0811-63.264-0.24421-20.479-0.0106-22.294v-6e-3c0-6.3597 2.0917-9.6653 5.0635-12.184 2.9694-2.5163 7.31-3.8742 10.829-3.8764h0.0106l2.0382-0.0383c0.0208 1.8e-4 0.0367 0 0.0569 0h56.626c11.351 0 20.822-4.9496 26.646-11.822 5.8275-6.877 8.3482-15.081 8.3813-23.108v-18.782h9.1644c2.3371 0 2.3387 6.94e-4 1.1702-2.3364l-18.437-36.484c-1.5733-2.696-0.74515-2.696-2.2626 0.07404z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    strokeWidth: 0.90254
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluxibilityLogo);
export default __webpack_public_path__ + "static/media/fluxibility-logo.66fc574eab3f7f6a6836f1c3d9f993aa.svg";
export { ForwardRef as ReactComponent };